// react core
import React from 'react';
// libs
import { check_if_email } from 'utils/helpers';

export default function IsEmailValidator({ username })
{
    if (username.length < 3) return (<></>);
    if (!check_if_email(username)) return (<div className='input-warning'>Please insert a valid email address</div>)
    return (<br/>)
}
